"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _providers = require("../../toolkit/providers");

var _TextInput = require("./TextInput");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propDoc = {
  options: {
    required: true,
    type: "ReadonlyArray<{ value: <T extends string>, text: string }> | ReadonlyArray<CategorizedOptions>",
    description: "List of options or a list of categorized options"
  },
  onSelected: {
    required: true,
    type: "(value: <T extends string>) => unknown",
    description: "Callback for when an option is selected"
  },
  selectedValue: {
    required: false,
    defaultValue: "null",
    type: "?<T extends string>",
    description: "Value of the currently selected option"
  },
  placeholder: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "Placeholder value for when no option has been selected"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the input is disabled. Set to true when " + "making API call"
  },
  showArrow: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if input should show the dropdown arrow "
  }
};
var demoProps = {
  options: [{
    category: "category1",
    optionsList: [{
      value: "1",
      text: "one"
    }, {
      value: "2",
      text: "two"
    }, {
      value: "3",
      text: "three"
    }]
  }, {
    category: "category2",
    optionsList: [{
      value: "4",
      text: "four"
    }, {
      value: "5",
      text: "five"
    }, {
      value: "6",
      text: "six"
    }]
  }],
  onSelected: function onSelected() {},
  selectedValue: "2",
  style: {
    minWidth: 120
  }
};

var SimpleSelect = function SimpleSelect(props) {
  var disabled = props.disabled,
      showArrow = props.showArrow,
      options = props.options,
      selectedValue = props.selectedValue,
      onSelected = props.onSelected,
      placeholder = props.placeholder,
      styleProp = props.style,
      hideBorder = props.hideBorder,
      className = props.className,
      selectProps = (0, _objectWithoutProperties2["default"])(props, ["disabled", "showArrow", "options", "selectedValue", "onSelected", "placeholder", "style", "hideBorder", "className"]);
  var isPlaceholder = selectedValue == null; // coersive quality includes undefined

  var styles = useStylesheet(props, isPlaceholder);
  var rootStyle = (0, _styling.css)(styles.root, className);

  var _useTheming = (0, _providers.useTheming)(),
      borderPrimary = _useTheming.theme.borderPrimary;

  var style = _objectSpread(_objectSpread(_objectSpread({}, styleProp), showArrow ? {
    marginRight: 8
  } : {
    margin: 0
  }), {}, {
    border: !hideBorder ? "solid 1px ".concat(borderPrimary) : "none"
  });

  if (options.length == 0) {
    return null;
  }

  var renderOptionElement = function renderOptionElement(_ref) {
    var text = _ref.text,
        value = _ref.value;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: "".concat(text).concat(value),
      value: value,
      className: (0, _styling.css)(styles.options)
    }, text);
  };

  var renderCategorizedOption = function renderCategorizedOption(option) {
    return /*#__PURE__*/_react["default"].createElement("optgroup", {
      key: option.category,
      label: option.category
    }, option.optionsList.map(function (option) {
      return renderOptionElement(option);
    }));
  }; // Need ternary to private get <select> to work

  /* eslint-disable local-rules/no-verbose-conditional */


  return /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({
    onChange: function onChange(e) {
      var newlySelectedValue = e.target.value;

      if (newlySelectedValue.trim().length === 0) {
        // we've defined the typing such that onSelected must only handle
        // undefined if a placeholder is passed in. newlySelectedValue will
        // only have value "" if it's from a placeholder. thus this is safe
        // but there's no way for the TS compiler to see that
        // @ts-ignore
        onSelected(undefined);
        return;
      }

      onSelected(newlySelectedValue); // newly selected value will be one of the <options>'s values
    },
    className: rootStyle,
    disabled: disabled,
    value: selectedValue || undefined,
    style: style
  }, selectProps), placeholder ? /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    className: (0, _styling.css)(styles.options)
  }, placeholder) : null, options.map(function (option) {
    if (option.category) {
      return renderCategorizedOption(option);
    }

    return renderOptionElement(option);
  }));
};

var useStylesheet = function useStylesheet(_ref2, isPlaceholder) {
  var disabled = _ref2.disabled,
      hideBorder = _ref2.hideBorder,
      showArrow = _ref2.showArrow;

  var _useTheming2 = (0, _providers.useTheming)(),
      _useTheming2$theme = _useTheming2.theme,
      textBlack = _useTheming2$theme.textBlack,
      textPlaceholder = _useTheming2$theme.textPlaceholder,
      inputBackground = _useTheming2$theme.inputBackground,
      fonts = _useTheming2.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: _objectSpread(_objectSpread({
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: inputBackground,
        padding: "0px ".concat(_TextInput.DEFAULT_PADDING, "px"),
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none"
      }, showArrow ? {
        background: "url(".concat(icons.chevronDown, ")"),
        backgroundPosition: "right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto 66%"
      } : {}), {}, {
        ":focus": {
          outline: "none"
        },
        color: isPlaceholder ? textPlaceholder : textBlack,
        fontFamily: fonts.regular,
        fontSize: _TextInput.DEFAULT_FONT_SIZE,
        borderRadius: !hideBorder ? 4 : undefined,
        opacity: disabled ? 0.5 : 1
      }),
      options: {
        color: textBlack
      }
    });
  }, [disabled, hideBorder, showArrow, isPlaceholder, textBlack, textPlaceholder, inputBackground, fonts.regular]);
};

SimpleSelect.propDoc = propDoc;
SimpleSelect.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(SimpleSelect);

exports["default"] = _default;